import Vue from 'vue';
import Vuex from 'vuex';
import { getInfo } from '@/api/login'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    User: {},
    permission: [],
    msgCount: {
      messages: 2
    },
    siderCollapsed: false
  },
  mutations: {
    SET_USER_INFO: (state, info) => {
      state.userInfo = info
    },
    updateAccount(state, data) {
      state.User = data;
    },
    updatePermission(state, data) {
      state.permission = data;
    },
    updateSiderCollapse(state, isShow) {
      setTimeout(() => {
        G.trigger('page_resize');
      }, 600);
      state.siderCollapsed = isShow;
    },
    updateMsgCount(state, data) {
      state.msgCount = data;
    }
  },
  actions: {
    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = (response && response.result) || {}
          commit('SET_USER_INFO', result)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateAccount(context, data) {
      context.commit('updateAccount', data);
    },
    updatePermission(context, data) {
      context.commit('updatePermission', data);
    },
    updateSiderCollapse(context, data) {
      context.commit('updateSiderCollapse', data);
    },
    updateMsgCount(context, data) {
      context.commit('updateMsgCount', data);
    },
  },
  getters: {
    userInfo: state => {
      return state.userInfo;
    },
    account: state => {
      return state.User;
    },
    siderCollapsed: state => {
      return state.siderCollapsed;
    },
    msgCount: state => {
      return state.msgCount;
    }
  }
});
